import React, { useState } from 'react';
import './LinkHovered.scss';

const LinkHovered = ({
    className,
    classNameLink,
    href,
    title,
    baseStyle,
    hoverStyle,
    anchorHoverStyle,
    anchorBaseStyle,
    children,
}) => {
    const [spanHovered, setHover] = useState(false);
    const [anchorHovered, setAnchorHover] = useState(false);
    const toggleHover = function () {
        setHover(!spanHovered);
    };
    const toggleAnchorHover = function () {
        setAnchorHover(!anchorHovered);
    };
    return (
        <span
            className={className ? 'link-hovered ' + className : 'link-hovered'}
            style={spanHovered ? hoverStyle : baseStyle}
            onMouseEnter={toggleHover}
            onMouseLeave={toggleHover}>
            <a
                className={
                    classNameLink
                        ? 'link-hovered ' + classNameLink
                        : 'link-hovered'
                }
                href={href}
                title={title}
                style={anchorHovered ? anchorHoverStyle : anchorBaseStyle}
                onMouseEnter={toggleAnchorHover}
                onMouseLeave={toggleAnchorHover}>
                {children}
            </a>
        </span>
    );
};
export default LinkHovered;
